<nav class="em-navbar navbar-expand-lg navbar-light sticky-top bg-light">
  <div class="container-fluid d-flex justify-content-between align-items-center">
    <a class="navbar-brand p-0 m-0" routerLink="/" (dblclick)="scrollTop()">
      <img [src]="headerData().logo" alt="Logo" loading="lazy" class="img-fluid d-inline-block agency-logo" />
    </a>
    @if (layout.showMobileMenu() === false) {
      <button (click)="layout.showMenu(true)" class="navbar-toggler" type="button">
        <span class="navbar-toggler-icon"></span>
      </button>
    }
    <div class="collapse navbar-collapse" id="navbar">
      <ul class="main-nav navbar-nav h-100 mb-lg-0 mx-auto">
        @for (item of parsedMenu(); track item.key) {
          @if (item.isVisible) {
            <li class="nav-item" [class.compact]="headerData()?.signed_agency?.signed_agency">
              @if (item.key === 'list' && headerData().list_external) {
                <a
                  class="nav-link"
                  [href]="[headerData().list_url]"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  target="_blank"
                  rel="noopener">
                  {{ item.title }}
                </a>
              } @else if (showProposals() && item.key === 'proposals') {
                <a class="nav-link" href="https://booking.valair.it/IT/holidays/search?" target="_blank" rel="noopener">
                  Viaggi Gattinoni
                </a>
              } @else {
                <a
                  class="nav-link"
                  [routerLink]="[item.link]"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }">
                  {{ item.title }}
                </a>
              }
            </li>
          }
        }
      </ul>
    </div>
    <div class="d-none nav-container">
      <ul class="desktop-nav navbar-nav flex-row align-items-center">
        @if (headerData()?.signed_agency?.signed_agency) {
          <li class="nav-item text-center">
            <a
              class="btn nav-btn cp rounded-0 text-white"
              [attr.href]="headerData().signed_agency?.link_url"
              rel="noopener noreferrer"
              target="_blank"
              >{{ headerData().signed_agency?.link_label }}</a
            >
          </li>
        }
        <li class="nav-item text-center">
          <a class="btn nav-btn cp rounded-0 text-white" routerLink="/newsletter"> Iscriviti alla newsletter </a>
        </li>
        @if (auth.isLoggedIn && showNavigation) {
          @if (!auth.isClient) {
            <li class="nav-item nav-icon cp">
              <a class="nav-link link-icon cp" routerLink="/back" placement="bottom" ngbTooltip="Pannello di controllo">
                <fa-icon class="icon text-color" [icon]="dashboardIcon"></fa-icon>
                <span class="visually-hidden">Pannello di controllo</span>
              </a>
            </li>
          }
          <li class="nav-item nav-icon cp" *canView="'client'" routerLinkActive="active">
            <a
              class="nav-link link-icon cp padding-fix"
              routerLink="/profile"
              placement="bottom"
              ngbTooltip="Il mio profilo">
              <fa-icon class="icon text-color" [icon]="userIcon"></fa-icon>
              <span class="visually-hidden">Profile</span>
            </a>
          </li>
          <li class="nav-item nav-icon cp" (click)="auth.logout().subscribe()">
            <a class="nav-link link-icon" title="Logout" placement="bottom" ngbTooltip="Logout">
              <fa-icon class="icon text-color" [icon]="logoutIcon"></fa-icon>
              <span class="visually-hidden">Logout</span>
            </a>
          </li>
        } @else {
          <li class="nav-item nav-icon">
            <a
              class="nav-link link-icon"
              routerLink="/auth/login"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              queryParamsHandling="merge"
              placement="bottom"
              ngbTooltip="Login">
              <fa-icon class="icon text-color" [icon]="loginIcon"></fa-icon>
              <span class="visually-hidden">Login</span>
            </a>
          </li>
          <li class="nav-item nav-icon">
            <a
              class="nav-link link-icon"
              routerLink="/auth/registrazione"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              queryParamsHandling="merge"
              placement="bottom"
              ngbTooltip="Registrati">
              <fa-icon class="icon text-color" [icon]="signUpIcon"></fa-icon>
              <span class="visually-hidden">Registrati</span>
            </a>
          </li>
        }
        @if (headerData()) {
          @if (headerData().pages.length) {
            <li class="nav-item nav-primary">
              <button type="button" title="menu" class="btn btn-em btn-em--flat nav-btn rounded-0">
                <span class="burger text-color">☰</span>
              </button>
              <div class="pages-dropdown">
                <ul class="page-list px-0">
                  @for (page of headerData().pages; track page.slug) {
                    <li>
                      <a [title]="page.title" [routerLink]="['/pagine', page.slug]" class="son">
                        <span>{{ page.title }}</span>
                      </a>
                    </li>
                  }
                </ul>
              </div>
            </li>
          }
        }
        @if (headerData().show_partner_logo) {
          <li>
            <img class="main-logo" src="assets/images/logo-dark.png" alt="gattinoni" loading="lazy" />
            <img loading="lazy" src="assets/images/logo-dark.png" alt="gattinoni logo" class="agency-logo mobile" />
          </li>
        }
      </ul>
    </div>
  </div>
</nav>
